export default "__VITE_ASSET__CHVOEFC$__"